//  font renamed as cardiuma-M - 23-08-24 - Dev Srini


const styles = theme => ({
    // Srini 07-01-25
    agentStatusText: {
        color: 'var(--b, #FFF)',
        textAlign: 'center',
        fontFamily: 'cardiuma-M !important',
        fontSize: '14px !important',
        fontStyle: 'normal',
        fontWeight: '500 !important',
        lineHeight: '18px !important',
        textTransform: 'capitalize',
        // marginLeft: '14%',

        '@media (max-width: 1200px)': {
            marginLeft: '10%',
            fontSize: '12px'
        },
        '@media (max-width: 900px)': {
            fontSize: '10px',
            marginLeft: '5%',
        },
        '@media (max-width: 380px)': {
            fontSize: '12px !important',
            marginLeft: '8%',
        },
    },

    optionsLayout: {
        display: 'flex',
        width: '150px',
        padding: '5px 10px',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '4px',
        border: '1px solid #DFE0EB',
        background: '#0B1420',
        flexWrap: 'nowrap'
    },

    optionsText: {
        color: 'var(--b, #FFF) ! important',
        textAlign: 'center',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '13px  ! important',
        fontStyle: 'normal ',
        fontWeight: '500  ! important',
        lineHeight: '18px  ! important',
        textTransform: 'capitalize  ! important'
    },

    modalHeading: {
        color: '#000',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '24px ! important',
        fontStyle: 'normal',
        fontWeight: '600 ! important',
        lineHeight: '18px ! important',
    },
    // outline removed - 25/08/24 - Dev Srini
    breakLayout1: {
        width: '736px',
        height: '230px',
        marginTop: '270px',
        marginLeft: '370px',
        flexShrink: 0,
        borderRadius: '14px',
        background: 'var(--b, #FFF)',
        border: 'none ! important ',
        outline: 'none ! important'
    },

    breakLayout2: {
        width: '156px',
        height: '116px',
        flexShrink: 0,
        borderRadius: '14px',
        border: '1px solid #000',
        background: '#FFF'
    },

    breakText: {
        color: '#000',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '16px ! important',
        fontStyle: 'normal',
        fontWeight: '600 ! important',
        lineHeight: '18px ! important'
    },
    // start to work btn styles - 25/08/24 - Dev Srini
    brkTxt: {
        fontSize: '16px',
        fontFamily: 'cardiuma-M ! important',
        fontWeight: '400 ! important',
    },

    strtWrkLyt: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        height: '100%',
        width: '100%',
        border: 'none ! important ',
        outline: 'none ! important'
    },

    strtWrkBtn: {
        padding: '8px 16px',
        backgroundColor: '#03C03C',
        color: '#fff',
        borderRadius: '4px',
        fontSize: '16px',
        fontFamily: 'cardiuma-M ! important',
        fontWeight: '400 ! important',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#03C03C',
        },
    },
    // font for app version - 22-10-24 dev Srini
    vrsnTxt: {
        color: '#fff ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '10px ! important',
        fontWeight: '400 ! important'
    },
    // Srini 07-01-25
    logoContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },

    logo: {
        width: '170px',
        height: 'auto',
        '@media (max-width: 900px)': {
            width: '120px',
        }
    },

    dashboardLink: {
        textDecoration: 'none',
    },

    userDetailsContainer: {
        display: 'flex',
        alignItems: 'center',
        // width: '100%',
        padding:"15px 0px 0px 20px "
    },

    iconStyle: {
        width: '24px',
        height: '24px',
        gap: '15px',
        flexShrink: 0,
    },


    // Add a new style to control the display of SipStatus
    '@media (max-width: 600px)': {
        '.showAbove600': {
            display: 'none !important',
        },
    }
})

export default styles
